import React from 'react';
import cn from 'classnames';
import { Checkbox } from '../../../../../../checkbox/esm';

var styles = {"desktop":"select__desktop_tguj5","mobile":"select__mobile_tguj5"};
require('./index.css');

var Header = function (_a) {
    var _b;
    var onChange = _a.onChange, checked = _a.checked, indeterminate = _a.indeterminate, mobile = _a.mobile, dataTestId = _a.dataTestId;
    return (React.createElement("div", { className: cn((_b = {}, _b[styles.desktop] = !mobile, _b[styles.mobile] = mobile, _b)) },
        React.createElement(Checkbox, { block: true, indeterminate: indeterminate, size: 'm', onChange: onChange, checked: checked, label: '\u0412\u044B\u0431\u0440\u0430\u0442\u044C \u0432\u0441\u0435', dataTestId: dataTestId })));
};

export { Header };
